import React  from 'react';
import { UserDetails } from '../../redux/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography,Grid} from '@mui/material';
import { styled } from '@mui/material/styles';
import './Styles.scss';
import Paper from '@mui/material/Paper';
import { PieChart  } from '@mui/x-charts/PieChart';
import { mobileAndDesktopOS ,valueFormatter} from '../../utils/webUsageStats';
import { LineChart } from '@mui/x-charts/LineChart';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


function HomeComp() {
  const { loading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
  
  // Sample data for "patient seen" and "patient cancelled" over 7 days
  const patientSeenData = [10, 15, 30, 50, 65, 80, 95];
  const patientCancelledData = [2, 5, 6, 3, 4, 7, 2];
  const xLabels = ['2024-11-01', '2024-11-02', '2024-11-03', '2024-11-04', '2024-11-05', '2024-11-06', '2024-11-07'];

  return (
    <>
    <Box className="rightContainer" sx={{ flexGrow: 1 }}>
    {/* <Typography component="h1" variant="h5" mb={2}>
        Welcome to {user ?user.firstName+" "+user.lastName:""}
      </Typography> */}
      
      <Grid container spacing={2}>
        {/* <Grid item xs={12}>
        <Typography component="h1" variant="h4" mb={2}>
          Appoinments 
        </Typography>
        </Grid> */}
        <Grid item xs={6}>
          <Typography component="h3" variant="h5" mb={2}>
            Appointments
          </Typography>
          <Item>
          <div style={{ width: '100%', height: 400 }}>
          <PieChart
            colors={['#FF5733', '#4CAF50']}
            series={[
              {
                data: [
                  { id: 0, value: 10, label: 'cancelled' },
                  { id: 1, value: 15, label: 'Seen' },
                ],
                innerRadius: 60,
                arcLabelMinAngle: 20,
                valueFormatter,
              },
            ]}
            // width={600}
            height={300}
          />
</div>
          </Item>
        </Grid>
        <Grid item xs={6}>
          <Typography component="h3" variant="h5" mb={2}>
            Patient Info
          </Typography>
          <Item>
          <div style={{ width: '100%', height: 400 }}>
            <LineChart
                // width={600}
                height={400}
                series={[
                  { data: patientSeenData, label: 'Seen', color: '#4CAF50' },
                  { data: patientCancelledData, label: 'Cancelled', color: '#FF5733' },
                ]}
                xAxis={[{ scaleType: 'point', data: xLabels }]}
                yAxis={[{ label: 'Count of Patients' }]}
              />
            </div>
          </Item>
        </Grid>
        
      </Grid>
    </Box>
    {/* <Box className="rightContainer">
            <Typography component="h1" variant="h5" mb={2}>
            Welcome to {user ?user.firstName+" "+user.lastName:""}
            </Typography>
            <Grid container  rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid size={6}>
              <Item>1</Item>
            </Grid>
            <Grid size={6}>
              <Item>2</Item>
            </Grid>
           
          </Grid>
    </Box> */}

    </>
    
  );
}

export default HomeComp;
